import { useState } from 'react'

export function useKeyValueFields(initialFields = []) {
  const [fields, setFields] = useState(initialFields)

  const setFieldValue = (idx, field, value) => {
    setFields((prev) => {
      const updated = [...prev]
      updated[idx][field] = value
      return updated
    })
  }

  const addField = () => setFields((prev) => [...prev, { key: '', value: '' }])
  const removeField = (idx) => setFields((prev) => prev.filter((_, i) => i !== idx))
  const resetFields = () => setFields([])

  return {
    fields,
    setFieldValue,
    addField,
    removeField,
    resetFields,
    setFields,
  }
}
